export default __webpack_public_path__ + "static/media/portfolioLoader.290c8582.gif";